// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__Fzrpn","author":"Table_author__H18sj","authorImage":"Table_authorImage__C0ut-","unreadRow":"Table_unreadRow__uOLsG"};